export const sendToCart = (properties, variationId) => {
    return fetch('/cart/add.js', {
        credentials: 'same-origin',
        method: 'post',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            id: variationId,
            quantity: 1,
            properties,
        }),
    }).then((r) => {
        if (r.ok) return r.json();
        throw new Error(`${r.status} in sendToCart(): ${r.statusText}`);
    });
};

export const getPropertiesFromCart = (variationId) => {
    if (process.env.NODE_ENV !== 'production') {
        const items = [
            {
                id: 1976663506988,
                properties: {
                    Riemenstärke: 'Schmal',
                    Riemenmaterial: 'Wildleder',
                    Riemenfarbe: 'Gelb/Beige',
                    Decksohle: 'Keine',
                    Lauffläche: 'Weiß',
                    Zwischensohle: 'Schwarz',
                    Laufsohlenstärke: 'Dünn',
                    Laufsohlenfarbe: 'Schwarz',
                },
                quantity: 1,
                variant_id: 1976663506988,
                key: '1976663506988:0b52277620b132156e66638b34afe692',
                title: 'Konfigurierter Flip Flop - Swarovski-Riehmen ohne Decksohle',
                price: 27900,
                original_price: 27900,
                discounted_price: 27900,
                line_price: 27900,
                original_line_price: 27900,
                total_discount: 0,
                discounts: [],
                sku: '',
                grams: 0,
                vendor: 'NOIN',
                taxable: true,
                product_id: 277584347180,
                gift_card: false,
                url: '/products/konfigurierter-flip-flop?variant=1976663506988',
                image: 'https://cdn.shopify.com/s/files/1/2780/1570/products/01.png?v=1517494881',
                handle: 'konfigurierter-flip-flop',
                requires_shipping: true,
                product_type: 'Flip Flop',
                product_title: 'Konfigurierter Flip Flop',
                product_description: '',
                variant_title: 'Swarovski-Riehmen ohne Decksohle',
                variant_options: ['Swarovski-Riehmen ohne Decksohle'],
            },
        ];

        const item =
            items.find((i) => i.key.toString() === variationId.toString()) ||
            {};

        const result = item.properties || null;

        return Promise.resolve(result);
    }

    return fetch('/cart.js', {
        credentials: 'include',
    })
        .then((r) => r.json())
        .then((d) => {
            const item =
                d.items.find(
                    (i) => i.key.toString() === variationId.toString()
                ) || {};
            return item.properties || null;
        });
};

// export const getPropertiesFromCart = variationId => {
//     return new Promise(res => {
//         setTimeout(() => {
//             const d = {
//                 items: [
//                     {
//                         id: '1976663539756',
//                         properties: {
//                             Decksohle: 'Moosgrün',
//                             Lauffläche: 'Weiß',
//                             Laufsohlenfarbe: 'Schwarz',
//                             Laufsohlenstärke: 'Dünn',
//                             Riemenfarbe: 'Schwarz',
//                             Riemenmaterial: 'Swarovski',
//                             Riemenstärke: 'Schmal',
//                             Zwischensohle: 'Schwarz',
//                         },
//                     },
//                 ],
//             };
//             const item = d.items.find(i => i.id === variationId) || {};
//             res(item.properties || null);
//         }, 600);
//     });
// };



// WEBPACK FOOTER //
// ./src/utils/shopify.js